var _require = require('crypto'),
    createCipheriv = _require.createCipheriv,
    createDecipheriv = _require.createDecipheriv,
    getCiphers = _require.getCiphers;

var _require2 = require('../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var _require3 = require('../errors'),
    JWEInvalid = _require3.JWEInvalid,
    JWEDecryptionFailed = _require3.JWEDecryptionFailed;

var _require4 = require('../help/key_object'),
    asInput = _require4.asInput;

var checkInput = function checkInput(size, iv, tag) {
  if (iv.length !== 12) {
    throw new JWEInvalid('invalid iv');
  }

  if (arguments.length === 3) {
    if (tag.length !== 16) {
      throw new JWEInvalid('invalid tag');
    }
  }
};

var encrypt = function encrypt(size, _ref, cleartext, _ref2) {
  var keyObject = _ref[KEYOBJECT];
  var iv = _ref2.iv,
      _ref2$aad = _ref2.aad,
      aad = _ref2$aad === void 0 ? Buffer.alloc(0) : _ref2$aad;
  var key = asInput(keyObject, false);
  checkInput(size, iv);
  var cipher = createCipheriv("aes-".concat(size, "-gcm"), key, iv, {
    authTagLength: 16
  });
  cipher.setAAD(aad);
  var ciphertext = Buffer.concat([cipher.update(cleartext), cipher.final()]);
  var tag = cipher.getAuthTag();
  return {
    ciphertext: ciphertext,
    tag: tag
  };
};

var decrypt = function decrypt(size, _ref3, ciphertext, _ref4) {
  var keyObject = _ref3[KEYOBJECT];
  var iv = _ref4.iv,
      _ref4$tag = _ref4.tag,
      tag = _ref4$tag === void 0 ? Buffer.alloc(0) : _ref4$tag,
      _ref4$aad = _ref4.aad,
      aad = _ref4$aad === void 0 ? Buffer.alloc(0) : _ref4$aad;
  var key = asInput(keyObject, false);
  checkInput(size, iv, tag);

  try {
    var cipher = createDecipheriv("aes-".concat(size, "-gcm"), key, iv, {
      authTagLength: 16
    });
    cipher.setAuthTag(tag);
    cipher.setAAD(aad);
    return Buffer.concat([cipher.update(ciphertext), cipher.final()]);
  } catch (err) {
    throw new JWEDecryptionFailed();
  }
};

module.exports = function (JWA, JWK) {
  ['A128GCM', 'A192GCM', 'A256GCM'].forEach(function (jwaAlg) {
    var size = parseInt(jwaAlg.substr(1, 3), 10);

    if (getCiphers().includes("aes-".concat(size, "-gcm"))) {
      JWA.encrypt.set(jwaAlg, encrypt.bind(undefined, size));
      JWA.decrypt.set(jwaAlg, decrypt.bind(undefined, size));

      JWK.oct.encrypt[jwaAlg] = JWK.oct.decrypt[jwaAlg] = function (key) {
        return (key.use === 'enc' || key.use === undefined) && key.length === size;
      };
    }
  });
};